module.exports = __webpack_public_path__ + "img/whatsapp.06122b54.png";